import {toggle}  from "../reducers/BarController";

export const toggleMenu = (toggleAction) => async (dispatch) => {
    dispatch(toggle({value: toggleAction}));
  };